import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-military-calisthenics': {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_mil_calisthenics_m_price~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-military-calisthenics&exp=web_mil_calisthenics_m_price~1
			upsell: {
				experiment: {
					'upsell-military-calisthenics-m': () =>
						import('@/modules/Upsell/instances/experiments/web_mil_calisthenics_m_price'),
				},
			},
		},
		'activity-male-military-calisthenics-pr': {
			// USD /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics-pr&exp=web_mil_calisthenics_m_price~1
			// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-military-calisthenics-pr&exp=web_mil_calisthenics_m_price~1
			upsell: {
				experiment: {
					'upsell-military-calisthenics-m': () =>
						import('@/modules/Upsell/instances/experiments/web_mil_calisthenics_m_price'),
				},
			},
		},
	},
]

export default config
